import * as React from 'react'

import { Backdrop } from './Backdrop'

import '../styles/Drawer.scss'

interface DrawerProps {
    isOpen: boolean
    closeOnOutsideClick?: boolean
    onClose?: () => void
}

interface DrawerState {
    isOpen: boolean
}

export class Drawer extends React.Component<DrawerProps, DrawerState> {

    constructor(props: any) {
        super(props)
        this.state = {
            isOpen: this.props.isOpen
        }
    }

    onClick = (event: any) => {
        // Prevents event handling on parent components
        this.close()
        event.stopPropagation()
    }

    onBackdropClick = () => {
        if (this.props.closeOnOutsideClick) {
            this.close()
        }
    }

    close = () => {
        this.setState(prevState => {
            return {
                isOpen: !prevState.isOpen
            }
        })
        if (this.props.onClose) {
            this.props.onClose()
        }
    }

    onDrawerKeyUp = (event:any) =>
    {
       if(event.keyCode == 27) //ESC
       {
           this.close()
           event.stopPropagation()
       }
    }

    render() {
        let className = 'drawer'
        if (this.props.isOpen) {
            className += ' open'
        }
        return (
            <Backdrop
                show={this.props.isOpen}
                onClick={this.onBackdropClick}
                classes={'for-drawer'}
            >
                <div
                    className={className}
                    onClick={this.onClick}
                    onKeyUp={this.onDrawerKeyUp}
                >
                    {this.props.children}
                </div>
            </Backdrop>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/Drawer.tsx